<template>
    <div>
        <form @submit.prevent class="m-form" name="headsOfLossForm">
            <div class="flex-grid a-form-inputs">
                <div class="flex-grid__item">
                    <control for="past_loss_of_services" label="Past Cost of Services" before-after="pound">
                        <input autocomplete="off" v-model.number="pastCostOfServices"
                               id="past_loss_of_services"
                               name="past_loss_of_services"
                               min="0"
                               v-two-dp
                               v-on:focus="pastCostOfServices = pastCostOfServices || ''"
                               v-on:blur="pastCostOfServices = pastCostOfServices || 0"
                               type="number">
                    </control>
                    <control for="past_cost_of_travel" label="Past Cost of Travel" before-after="pound">
                        <input autocomplete="off" v-model.number="pastCostOfTravel"
                               id="past_cost_of_travel"
                               name="past_cost_of_travel"
                               min="0"
                               v-two-dp
                               v-on:focus="pastCostOfTravel = pastCostOfTravel || ''"
                               v-on:blur="pastCostOfTravel = pastCostOfTravel || 0"
                               type="number">
                    </control>
                    <control for="miscellaneous_costs"
                             label="Miscellaneous - Medication, Appliances, Additional Food & Energy Costs"
                             before-after="pound">
                        <input autocomplete="off" v-model.number="misc"
                               id="miscellaneous_costs"
                               name="miscellaneous_costs"
                               min="0"
                               v-two-dp
                               v-on:focus="misc = misc || ''"
                               v-on:blur="misc = misc || 0"
                               type="number">
                    </control>
                    <div v-for="index in customHeadsOfLoss.length">
                        <head-of-loss @update="updateValid" :index="index - 1"></head-of-loss>
                    </div>

                    <button class="a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20" @click="addCustomHeadOfLoss">
                        Add Another Head of Loss
                    </button>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                     <control label="Past Cost of Care"
                             tip-text="You have two options to assess the past cost of care claim."
                             tip-icon="info"
                             tip-side="left"
                             tip-width="200"
                             tip-name="care">
                        <select id="careCalcType" v-model="careCalcType" v-field-control @change="updateValid">
                            <option value="own">Enter your own figure</option>
                            <option value="manual">Detailed calculation</option>
                        </select>
                    </control>
                    <control for="pastCostOfCare" v-if="careCalcType === 'own'" label="Enter Your Own Figure"
                             before-after="pound">
                        <input autocomplete="off"
                               v-model.number="pastCostOfCare"
                               name="pastCostOfCare"
                               min="0.00"
                               v-on:focus="pastCostOfCare = pastCostOfCare || ''"
                               v-on:blur="pastCostOfCare = pastCostOfCare || 0"
                               v-two-dp
                               v-field-control:pastCostOfCare.valid="{type:'number', rules:'valid'}">
                        <control-error :show="$error('pastCostOfCare')">
                            Your own care figure should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <div v-for="index in periods.length" v-if="careCalcType === 'manual'">
                        <period @update="updateValid" :index="index - 1"></period>
                    </div>
                    <button class="a-button a-button--no-margin"
                            v-if="periods.length >= 0 && careCalcType === 'manual'"
                            @click="addCarePeriod"
                            style="margin-bottom: 40px;">
                        Add Period
                    </button>
                    <control for="care_total" label="Care Total" before-after="pound">
                        <input autocomplete="off" :value="currencyFormat(pastCostOfCare, '')" type="text" disabled>
                    </control>
                </div>
            </div>
        </form>

        <step-button :next-valid="isValid()"></step-button>
    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import FormValidator from 'components/form/validator/mixin';
    import HeadOfLoss from 'pages/personal-injury-claims/steps/heads-of-loss/HeadOfLoss.vue';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';
    import Period from 'pages/personal-injury-claims/steps/heads-of-loss/Period.vue';
    import StepButton from 'components/StepButton.vue';
    import {setStepValid} from 'services/routingMethods';
    import {mapActions, mapGetters} from 'vuex';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'other-past-losses',
        mixins: [
            FormValidator,
            currencyFormat
        ],
        components: {
            Control,
            ControlError,
            StepButton,
            HeadOfLoss,
            Period,
            Modal,
            ModalContent,
        },
        mounted() {
            if (this.value('careCalcType') === null) {
                this.set({key: 'careCalcType', value: 'own'});
            }
            setStepValid(true);
        },
        computed: {
            ...mapGetters('personal/otherPastLosses', [
                'value',
                'allCarePeriodsValid',
                'allCustomHeadOfLossValid'
            ]),
            ...mapGetters('personal/claimant', ['getClaimantDetail']),
            ...mapGetters('modal', ['modals']),
            pastCostOfServices: {
                get() {
                    return this.value('pastCostOfServices');
                },
                set(value) {
                    this.set({key: 'pastCostOfServices', value});
                }
            },
            pastCostOfTravel: {
                get() {
                    return this.value('pastCostOfTravel');
                },
                set(value) {
                    this.set({key: 'pastCostOfTravel', value});
                }
            },
            misc: {
                get() {
                    return this.value('misc');
                },
                set(value) {
                    this.set({key: 'misc', value});
                }
            },
            customHeadsOfLoss: {
                get() {
                    return this.value('headsOfLoss');
                },
            },
            careCalcType: {
                get() {
                    return this.value('careCalcType');
                },
                set(value) {
                    this.set({key: 'careCalcType', value});
                }
            },
            pastCostOfCare: {
                get() {
                    return this.value('pastCostOfCare');
                },
                set(value) {
                    this.set({key: 'pastCostOfCare', value});
                }
            },
            periods: {
                get() {
                    return this.value('periods');
                },
            },
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        watch: {
            ['$form.$valid']() {
                this.updateValid()
            },
            ['periods']() {
                this.updateValid()
            },
            ['customHeadsOfLoss']() {
                this.updateValid()
            },
        },
        methods: {
            ...mapActions('personal/otherPastLosses', {
                set: 'set',
                addCustomHeadOfLoss: 'addCustomHeadOfLoss',
                addCarePeriod: 'addCarePeriod'
            }),
            ...mapActions('personal/generalDamages', {
                updateValue: 'updateValue',
            }),
            ...mapActions('modal', ['toggle']),
            updateValid() {
                setStepValid(this.isValid());
            },
            isValid() {
                let headsOfLossValid = true;
                let carePeriodsValid = true;

                if (this.careCalcType === 'manual') {
                    carePeriodsValid = this.allCarePeriodsValid();
                }

                if (this.customHeadsOfLoss.length) {
                    headsOfLossValid = this.allCustomHeadOfLossValid;
                }

                return this.$valid() && carePeriodsValid && headsOfLossValid;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// OtherPastLosses.vue?5e4c2e78